// Breakpoints here should be the same as CSS breakpoints of the given theme.
const breakpoints = {
  smallMin: 768,
  mediumMin: 992,
  extraMediumMin: 1024,
  largeMin: 1200,
  extraLargeMin: 1366,
  gridFloatBreakpoint: 768,
};

// We don't use Object.assign here, because we didn't load polyfills yet
for (let b in Skubacz.configuration.breakpoints) {
  breakpoints[b] = Skubacz.configuration.breakpoints[b];
}

const mediaQuery = {
  xsmall: "(max-width: " + (breakpoints.smallMin - 1) + "px)",
  small:
    "(min-width: " +
    breakpoints.smallMin +
    "px) and (max-width: " +
    (breakpoints.mediumMin - 1) +
    "px)",
  medium:
    "(min-width: " +
    breakpoints.mediumMin +
    "px) and (max-width: " +
    (breakpoints.largeMin - 1) +
    "px)",
  large: "(min-width: " + breakpoints.largeMin + "px)",
  gridFloatBreakpointUp: `(min-width: ${breakpoints.gridFloatBreakpoint}px)`,
  gridFloatBreakpointDown: `(max-width: ${
    breakpoints.gridFloatBreakpoint - 1
  }px)`,
};

const isExtraSmall = () => window.matchMedia(mediaQuery.xsmall).matches;
const isSmall = () => window.matchMedia(mediaQuery.small).matches;
const isMedium = () => window.matchMedia(mediaQuery.medium).matches;
const isLarge = () => window.matchMedia(mediaQuery.large).matches;

const isSmallUp = () => isSmall() || isMedium() || isLarge();
const isMediumUp = () => isMedium() || isLarge();

// deprecated - use isSmallUp
const isSmallMin = () => !isExtraSmall();
// deprecated - use isMediumUp
const isMediumMin = () => isMedium() || isLarge();

// find better name
const isMobileSize = () =>
  window.matchMedia(mediaQuery.gridFloatBreakpointDown).matches;

const getWidth = () => window.innerWidth;
const getHeight = () => window.innerHeight; //$(window).innerHeight() //mobile safari bug!!!

// TODO isChrome isChromeMobile isChromeDesktop
const isChrome = () => !!window.chrome && !!window.chrome.webstore;
// TODO isSafari isSafariMobile isSafariDesktop
const isSafari = () => /^((?!chrome).)*safari/i.test(navigator.userAgent);
const isFirefox = () => /firefox/i.test(navigator.userAgent);
const isEdge = () => /edg/i.test(navigator.userAgent);

const getScrollY = () =>
  window.pageYOffset ||
  document.body.scrollTop ||
  document.documentElement.scrollTop;

const isMobileApp = () => {
  try {
    return window.RestaumaticMobileApp.isMobileApp();
  } catch (e) {
    return false;
  }
};

const getMobileAppType = () => {
  try {
    return window.RestaumaticMobileApp.getAppType();
  } catch (e) {
    return "";
  }
};

const isInIframe = () => {
  try {
    return window.self != window.top;
  } catch (e) {
    return true;
  }
};

// is-touch-device | https://github.com/airbnb/is-touch-device | MIT license
const isTouch = () => {
  return (
    !!(
      typeof window !== "undefined" &&
      ("ontouchstart" in window ||
        (window.DocumentTouch &&
          typeof document !== "undefined" &&
          document instanceof window.DocumentTouch))
    ) ||
    !!(
      typeof navigator !== "undefined" &&
      (navigator.maxTouchPoints || navigator.msMaxTouchPoints)
    )
  );
};

const mobileGeolocationEnabled = () => {
  try {
    return window.RestaumaticMobileApp.mobileGeolocationEnabled();
  } catch (e) {
    return false;
  }
};

/**
 * Gets the device type based on the user agent string.
 * This covers 98% of the device_type parser used in Ruby on the backend (sometimes assigns Mobile instead of Phablet or Tablet but it's not the end of the world :D)
 *
 * @returns {'Desktop' | 'Mobile' | 'Tablet'} - The device type.
 */
const getDeviceType = () => {
  const userAgent = navigator?.userAgent ?? "";
  const ua = userAgent.toLowerCase();
  if (!ua) return "Desktop"; // fallback
  if (
    /mobile|android|iphone|ipod|blackberry|iemobile|kindle|silk-accelerated|(hpw|web)os|opera mini/.test(
      ua
    )
  ) {
    return "Mobile";
  }
  if (/ipad|tablet|playbook|silk/.test(ua)) {
    return "Tablet";
  }
  return "Desktop";
};

/**
 * Detects the user's Operating System name from the user agent string
 * This covers ~99% of the `os` parser used in Ruby on the backend
 *
 * @returns {'Windows' | 'Mac' | 'Linux' | 'Chrome OS' | 'Android' | 'iOS' | 'Unknown'} - The OS name.
 */
const getOSName = () => {
  const ua = navigator.userAgent;
  const platform = navigator.platform || "";

  if (/Android|HarmonyOS/.test(ua)) return "Android";
  if (/iPhone|iPad|iPod|iOS|iPadOS|CPU.*OS.*like Mac OS X/.test(ua))
    return "iOS";
  if (/Windows NT|Windows|Win32|Win64|WOW64/.test(ua)) return "Windows";
  if (
    /Macintosh|Mac OS X|MacIntel|MacPPC|Mac_PowerPC/.test(ua) ||
    /Macintosh/.test(platform)
  )
    return "Mac";
  if (/CrOS|Chrome OS/.test(ua)) return "Chrome OS";
  if (
    /Linux|X11|Ubuntu|Debian|Fedora|Red Hat|SUSE|Gentoo|Arch|GNU\/Linux|Tizen/.test(
      ua
    )
  )
    return "Linux";
  return "Unknown";
};

/**
 * Detects the user's Browser name from the user agent string.
 * This covers ~99% of the `browser` parser used in Ruby on the backend (some browsers like `Facebook`, `Samsung Browser` etc. are grouped into Chrome/Safari to simplify things)
 *
 * @returns {'Edge' | 'Opera' | 'Chrome Mobile iOS' | 'Chrome' | 'Firefox' | 'Internet Explorer' | 'Safari' | 'Unknown'} - The browser name.
 */
const getBrowserName = () => {
  const ua = navigator.userAgent;

  if (/Edg\/|EdgA\//.test(ua)) return "Edge";
  if (/OPR\/|OPT\/|Opera|OPX\//.test(ua)) return "Opera";
  if (/CriOS\//.test(ua)) return "Chrome Mobile iOS";
  if (/Chrome\/|Brave\/|wv\).*Chrome\/|(; wv\).*Chrome\/)/.test(ua))
    return "Chrome";
  if (
    /(AppleWebKit\/.*(iPhone|iPod|iPad|iOS))|(Safari\/(?!.*Chrome\/)(?!.*Edg\/)(?!.*CriOS\/))/.test(
      ua
    )
  )
    return "Safari";
  if (/FxiOS\/|Firefox\//.test(ua)) return "Firefox";
  if (/msie\/|trident\//.test(ua)) return "Internet Explorer";
  return "Unknown";
};

export default {
  breakpoints: breakpoints,
  mediaQuery,
  screen: {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge,
    isSmallUp,
    isMediumUp,
    isSmallMin,
    isMediumMin, // deprecated
    isMobileSize, // find better name
    getWidth,
    getHeight,
  },
  browser: {
    isChrome,
    isSafari,
    isFirefox,
    isEdge,
  },
  isMobileApp,
  getMobileAppType,
  isInIframe,
  mobileGeolocationEnabled,
  getScrollY,
  isTouch,
  getDeviceType,
  getOSName,
  getBrowserName,
};
